import getFormComponent from '../getFormComponent';
import schemas from 'src/products/admin/redux/forms/schemas';

const GlobalSettings = getFormComponent(schemas['global-settings']);

export default GlobalSettings;
